import { useEffect, useState } from 'react';
import { Button, Modal } from '../components/ui';
import '../components/ui/common.css';
import { settingsAPI, workoutsAPI } from '../services/api';

const Workouts = () => {
    const [workouts, setWorkouts] = useState([]);
    const [summary, setSummary] = useState([]);
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingWorkout, setEditingWorkout] = useState(null);
    const [formData, setFormData] = useState({ workoutTypeId: '', durationMinutes: '', date: '' });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const [workoutsRes, summaryRes, typesRes] = await Promise.all([
                workoutsAPI.getAll(),
                workoutsAPI.getSummary(),
                settingsAPI.getWorkoutTypes()
            ]);
            setWorkouts(workoutsRes.data);
            setSummary(summaryRes.data);
            setTypes(typesRes.data);
        } catch (error) {
            console.error('Error loading data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingWorkout) {
                await workoutsAPI.update(editingWorkout.id, formData);
            } else {
                await workoutsAPI.create(formData);
            }
            setModalOpen(false);
            setEditingWorkout(null);
            setFormData({ workoutTypeId: '', durationMinutes: '', date: '' });
            loadData();
        } catch (error) {
            console.error('Error saving workout:', error);
            alert('Ошибка при сохранении');
        }
    };

    const handleEdit = (workout) => {
        setEditingWorkout(workout);
        setFormData({
            workoutTypeId: workout.workoutTypeId,
            durationMinutes: workout.durationMinutes,
            date: workout.date.split('T')[0]
        });
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить тренировку?')) return;
        try {
            await workoutsAPI.delete(id);
            loadData();
        } catch (error) {
            console.error('Error deleting workout:', error);
            alert('Ошибка при удалении');
        }
    };

    const openAddModal = () => {
        setEditingWorkout(null);
        setFormData({
            workoutTypeId: types.length > 0 ? types[0].id : '',
            durationMinutes: '',
            date: new Date().toISOString().split('T')[0]
        });
        setModalOpen(true);
    };

    if (loading) {
        return <div className="loading">Загрузка...</div>;
    }

    return (
        <div>
            <div className="page-header">
                <h1>Тренировки</h1>
                <Button onClick={openAddModal}>+ Добавить</Button>
            </div>

            {summary.length > 0 && (
                <div className="summary-grid">
                    {summary.map((item) => (
                        <div key={item.workoutTypeId} className="summary-card">
                            <div className="summary-label">{item.workoutType?.name || '—'}</div>
                            <div className="summary-value">{item.totalMinutes} мин</div>
                        </div>
                    ))}
                </div>
            )}

            {workouts.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">💪</div>
                    <p>Нет тренировок</p>
                    <Button onClick={openAddModal}>Добавить первую тренировку</Button>
                </div>
            ) : (
                <div>
                    {workouts.map((workout) => (
                        <div key={workout.id} className="list-item">
                            <div className="list-item-content">
                                <div style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                                    {workout.durationMinutes} мин — {workout.workoutType?.name || '—'}
                                </div>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                    {new Date(workout.date).toLocaleDateString('ru-RU')}
                                </div>
                            </div>
                            <div className="list-item-actions">
                                <button className="icon-btn" onClick={() => handleEdit(workout)}>✏️</button>
                                <button className="icon-btn" onClick={() => handleDelete(workout.id)}>🗑️</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <Modal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={editingWorkout ? 'Редактировать тренировку' : 'Добавить тренировку'}
                footer={
                    <>
                        <Button variant="secondary" onClick={() => setModalOpen(false)}>Отмена</Button>
                        <Button onClick={handleSubmit}>Сохранить</Button>
                    </>
                }
            >
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="workoutTypeId">Тип тренировки</label>
                        <select
                            id="workoutTypeId"
                            value={formData.workoutTypeId}
                            onChange={(e) => setFormData({ ...formData, workoutTypeId: e.target.value })}
                            required
                        >
                            <option value="">Выберите тип</option>
                            {types.map((type) => (
                                <option key={type.id} value={type.id}>{type.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="durationMinutes">Длительность (минут)</label>
                        <input
                            id="durationMinutes"
                            type="number"
                            min="1"
                            value={formData.durationMinutes}
                            onChange={(e) => setFormData({ ...formData, durationMinutes: e.target.value })}
                            required
                            placeholder="30"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="date">Дата</label>
                        <input
                            id="date"
                            type="date"
                            value={formData.date}
                            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                            required
                        />
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Workouts;
